import { HttpClient } from "@angular/common/http"
import { Injectable } from "@angular/core"
import { Observable } from "rxjs"
import { environment } from "src/environments/environment"
import { PdfFileResult } from "../models"

@Injectable({
    providedIn: "root",
})
export class StaticFilesService {
    private _apiUrl = environment.apiBaseUrl + environment.endpointRoutes.staticFiles

    constructor(private http: HttpClient) {}

    GetPdfFile(filename: string): Observable<PdfFileResult> {
        return this.http.get<PdfFileResult>(this._apiUrl + `/${filename}`)
    }
}
